// extracted by mini-css-extract-plugin
module.exports = {"container":"yq","heading":"zq","image":"Aq","text":"Bq","infoWrapper":"Cq","info":"Dq","link":"Eq"};